import AuthorityBuilder from 'pojos/AuthorityBuilder.js'

const FinancialCommissionReport = new AuthorityBuilder({
	accessGroup: 'FINANCIAL_COMMISSION_REPORT',
	accessType: ['ACCESS', 'LIST_READ', 'LIST_EXPORT_READ']
})

export default [
	FinancialCommissionReport
]
